<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content *ngIf="data.message">
	<p class="confirm-dialog__message">{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button type="button" [mat-dialog-close]="false">{{ data.cancel_label || ('Cancel' | tt) }}</button>
	<button mat-flat-button type="button" [color]="data.is_destructive ? 'warn' : 'primary'" [mat-dialog-close]="true">
		{{ data.ok_label || ('Confirm' | tt) }}
	</button>
</mat-dialog-actions>
